export class AttestationContent {
    contentInfo?: {fr:string, en:string, value:string}[];
    motif?: {fr:string, en:string, value:string};
}